const

	//加载确认订单信息的模板
	confirmOrderMsg = require('../templates/confirmOrderMsg.ejs'),

	//跳转到指定页面的函数
	// changeToPage = require('./commonTools.js').changeToPage,

  addDays = require('../../../common/util').addDays

	// 关闭窗口的函数（兼容各个浏览器）
	CloseWebPage = require('./commonTools.js').CloseWebPage;


//用户点击支付时，检查信息是否填写完整
function isComplete() {
	//因为其他地方都是预先填好的，用户只能改不能删，所以只需要验证入住信息与验证方式非在线验证时信息是否为空
	$('.t-o-c-ticket-button').click(function () {
        //******** 提交表单之前进行验证

				if (!$("#orderForm").myValid()) {
					//将页面回滚到第一个验证不通过的地方
					//获取第一个验证不通过的元素的位置
					var failedTest = $('.error')[0].offsetTop - 80;

					$('body, html').animate({
						scrollTop: failedTest + "px"
					}, 200);

					return;
				} else {
          // 所有人员信息电话要不一样
          const list = $(".ticketUserInfoDetail .ticketTel")
          const tels = []
          for (let i =0 ;i < list.length;i++) {
            tels.push(list[i].value)
          }
          if (isRepeat(tels)) {
            layer.open({
              title: '提示'
              ,content: '每个游客电话号码要求唯一'
            });
            return
          }
					//验证通过则将页面中信息取出，替换到确认信息框中
					alertConfirmMsg();
				}
			}
	)
}

// 是否有相同元素
function isRepeat(arr) {
  var hash = {};
  for(var i in arr) {
    if(hash[arr[i]]) {
      return true;
    }
    hash[arr[i]] = true;
  }
  return false;
}

function alertConfirmMsg() {
	//处理该数据
	var formObj = {};
// 获取门票信息
  let o = $.orderInfo.data;
  formObj.clauseDesc = o.ticketPriceModel.clauseDesc;
  formObj.innerRemark = '';
  formObj.supplierRemark = 'aa';
  formObj.distrbId = o.ticketPriceModel.distrbId;
  formObj.distrbName = o.ticketPriceModel.distrbName;
  formObj.customId = o.ticketPriceModel.customId;
  formObj.customName = o.ticketPriceModel.customName;
  formObj.distrbName = o.ticketPriceModel.distrbName;
  formObj.infoId = o.ticketPriceModel.infoId;
  formObj.itemId = o.ticketPriceModel.itemId;
  formObj.ticketRangeId = o.ticketPriceModel.ticketRangeId;
  formObj.itemName = o.ticketPriceModel.infoName;
  formObj.suppId = o.ticketPriceModel.suppId;
  // formObj.suppName = o.ticketPriceModel.suppName;
  formObj.suppName = o.ticketPriceModel.suppName;
  formObj.acount = $('#ticketNum').val();
  formObj.paymentTerm = $('#balance-way').val();
  formObj.suppPaymentTerm = o.ticketPriceModel.suppPaymentTerm;
  formObj.currency = o.currency;
  formObj.currencyRate = o.currencyRate;
  formObj.basePrice = parseFloat(o.ticketPriceModel.basePrice*formObj.acount);
  formObj.salePrice = parseFloat(o.ticketPriceModel.salePrice*formObj.acount);
  formObj.paymentStatus = 0;
  formObj.customerOrderCode = $('#useOrderNum').val();
  let useBalanceAmount = parseFloat($('#usePerPayment').val())
  if(useBalanceAmount){
    formObj.useBalanceAmount = useBalanceAmount;
  }
  let connectionName = $('.connectionName').val().toUpperCase();
  let connectionTel = $('.connectionTel').val()
  let connectionMail = $('.connectionMail').val()
  if(connectionName){
    formObj.bookerUserCheckInName  = connectionName;
  }
  if(connectionTel){
    formObj.bookerUserMobilePhone = connectionTel;
  }
  if(connectionMail){
    formObj.bookerUserEmail = connectionMail;
  }

  //入住人信息

  formObj.orderUser = {};
  var divTr =  $(".ticketUserInfoDetail");
  var userSize = divTr.length;
  let nameArr = [];
  if(divTr.length > 0){

    for(var index=0;index <userSize;index++){
      var divs = $(divTr[index]);
      var firstName =divs.find('.t-o-c-userFirstName').val().toUpperCase(),
        lastName = divs.find('.t-o-c-userLastName').val().toUpperCase();
      formObj["orderUserList["+index+"].userName"] = firstName+lastName;
      formObj["orderUserList["+index+"].firstName"] = firstName;
      formObj["orderUserList["+index+"].lastName"] = lastName;
      nameArr.push(firstName.trim()+lastName.trim())

      var sex = divs.find("[name=sex]:checked").val();
      var birthPlace = divs.find("[name=birthPlace]").val();
      var airPlace = divs.find("[name=airPlace]").val();
      var phone = divs.find("[name=voucherMobile]").val();
      var email = divs.find("[name=voucherEmail]").val();
      var cardType = divs.find("[name=cardType]").val();
      var card = cardType === "1" ? divs.find("[name=voucherCard]").val() : divs.find("[name=voucherOtherCard]").val();
      var cardTypeNum = cardType === "1" ? divs.find("[name=voucherCard]").attr('data-value') : divs.find("[name=voucherOtherCard]").val();
      
    //   console.log('cardType',cardType);
    //   console.log("card",card);
    //   console.log("cardTypeNum",cardTypeNum);

      if(phone ){
        formObj["orderUserList["+index+"].mobilePhone"]=phone;
      }
      if(email ){
        formObj["orderUserList["+index+"].email"]= email;
      }
      if(card ){
        formObj["orderUserList["+index+"].cardNo"]=card;
      }
      if(cardType || cardTypeNum){
        formObj["orderUserList["+index+"].cardType"]=cardType ||cardTypeNum;
      }
      if(sex ){
        formObj["orderUserList["+index+"].sex"]=sex;
      }
      if(birthPlace ){
        formObj["orderUserList["+index+"].birthPlace"]=birthPlace;
      }
      if(airPlace ){
        formObj["orderUserList["+index+"].airPlace"]=airPlace;
      }

      var isRealName = $("[name=isRealNameHidden]").val();
      if(isRealName){
        formObj["orderUserList["+index+"].cardType"]=divs.find("[name=cardType]").val();
        formObj["orderUserList["+index+"].cardNo"]=divs.find("[name=cardNo]").val();
      }
    }
  }

  // formObj.orderUser = {};
  // formObj.orderUser.userName = 'aa';
  // formObj.orderUser.firstName = 'a';
  // formObj.orderUser.lastName = 'a';
  // formObj.orderUser.email = '11@qq.com';
  formObj.checkInDate = addDays($('#ticketCalenderPrice').val(),0,'-');
  formObj.ticketPriceModelList = [];
  var ticketPriceModelList = {};
  formObj["ticketPriceModelList[0].stockId"] = o.ticketPriceModel.stockId;
  formObj["ticketPriceModelList[0].validDate"]= addDays($('#ticketCalenderPrice').val(),0,'-');
  formObj["ticketPriceModelList[0].basePrice"] = o.ticketPriceModel.basePrice;
  formObj["ticketPriceModelList[0].salePrice"] = o.ticketPriceModel.salePrice;
  formObj["ticketPriceModelList[0].ticketType"] = o.ticketPriceModel.ticketType;
  formObj["ticketPriceModelList[0].priceType"] = o.ticketPriceModel.priceType;
  formObj["ticketPriceModelList[0].ticketTypeName"] = o.ticketPriceModel.ticketTypeName;
  formObj["ticketPriceModelList[0].priceTypeName"] = o.ticketPriceModel.priceTypeName;
  formObj["ticketPriceModelList[0].paymentType"] = o.ticketPriceModel.paymentType;
  formObj["ticketPriceModelList[0].formulaType"] = o.ticketPriceModel.formulaType;
  // 2020-11-20 修改room和count保持一致
  // formObj["ticketPriceModelList[0].room"] = o.ticketPriceModel.room;
  formObj["ticketPriceModelList[0].room"] = formObj.acount;
  formObj["ticketPriceModelList[0].ticketRangeId"] = o.ticketPriceModel.ticketRangeId;
  formObj["ticketPriceModelList[0].itemId"] = o.ticketPriceModel.itemId;
  // // formObj["ticketPriceModelListObj[0].stockId"]
  formObj.ticketType = o.ticketPriceModel.ticketType;
  formObj.priceType = o.ticketPriceModel.priceType;;
  formObj.ticketTypeName = o.ticketPriceModel.ticketTypeName;
  formObj.priceTypeName = o.ticketPriceModel.priceTypeName;
  formObj.paymentType = o.ticketPriceModel.paymentType;
  formObj.formulaType = o.ticketPriceModel.formulaType;
  formObj.checkOutDate = addDays($('#ticketCalenderPrice').val(),1,'-');
  formObj.originalPrice = o.ticketPriceModel.basePrice;
  formObj.originalBasePrice = o.ticketPriceModel.salePrice;
  //
  //
  formObj.ticketPriceModelList[0] = ticketPriceModelList;
  // formObj.orderUser = $.param(formObj.orderUser);
  // // formObj = $.param(formObj);

  //数据组装
  // console.log(o)
  // 场次选择
  var screening = $('.screeningChosse').val();
  if (screening) {
    const item = o.lyShow.find(item => item.ShowId === screening)
    formObj.screeningId = item.ShowId;
    formObj.screeningBeginTime = item.ShowBeginTime;
    formObj.screeningEndTime = item.ShowEndTime;
    formObj.screeningName = item.ShowName;
  }
  console.log(formObj)


  //将获取的数据嵌入弹出的确认订单信息框中
	var confirmOrderDOM = layer.open({
		type: 1,
		title: false,
		offset: '60px',
		closeBtn: 0,
		move: '.palce-can-move',
    shade: 0.5,
		content: confirmOrderMsg({data:formObj})
  });
  for(let i in nameArr){
    $('.t-o-c-player').append(`<span>游玩人${parseInt(i)+1}</span><p>${nameArr[i]}</p>`)
  }
  $('.ticketCancelContent').text(o.ticketPriceModel.clauseDescShow)
  let balanceWay = $('#balance-way').attr('data-method') || $('#balance-way').find('option[selected]').text().trim() || $('#balance-way').find('option[value=0]').text().trim()
  // console.log(balanceWay)
  $('.ticketBalanceWay').text(balanceWay)


	//用户点击确认之后，隐藏确认订单信息框
	$('.confirm-order-msg').on('click', '.confirm-order', function () {
		layer.close(confirmOrderDOM);
		sendData(formObj);
	});
	//用户点击取消之后，隐藏确认订单信息框
	$('.confirm-order-msg').on('click', '.cancel-order', function () {
		layer.close(confirmOrderDOM);
	});

	return false;
}

//用户确认订单信息后，验价并发送数据
function sendData(formObj) {
	//进行验价
	//获取参数

	//发送请求
	createOrder(formObj);
}

//创建订单
function createOrder(formObj) {
    //验价
    const checkThePrice = require('./sendRequest.js').checkThePrice;
    checkThePrice(formObj, function (res) {

      if (res.returnCode ===1){
        // location.href = `/internalOrder/pay.do?orderId=${res.data.orderInfoId}`
        // location.href = `/ticketOrderSuccess.html?orderInfoId=${res.data.orderInfoId}`
        if(res.data.nonFinish){
          // location.href = `/internalOrder/pay.do?orderId=${res.data.orderInfoId}`
          location.href = `/pay/toPayOrCharge.do?payMethod=2&orderId=${res.data.orderInfoId}`
          // checkThePrice(formObj,function (res) {
          //   if(res.returnCode ===1){
          //   }else if(res.returnCode === -400001){
          //     alert('请先登录',{closeBtn : 0},function () {
          //       //跳转到首页
          //       location.href = '/user/home.do';
          //     });
          //   }else {
          //     //否则就提示用户错误信息，然后跳转到酒店详情页面
          //     alert(res.returnMsg,{closeBtn : 0},function(){
          //       changeToPage();
          //     });
          //   }
          // });
        }else {
          location.href = `/ticketController/toTicketOrderSuccess.do?subOrderCode=${res.data.orderId}&orderId=${res.data.orderInfoId}`
        }
      } else if ( res.returnCode === -400001){
        alert('请先登录',{closeBtn : 0},function () {
          //跳转到首页
          location.href = '/user/home.do';
        });
      } else if (res.returnCode === -401001){
        layer.confirm(res.returnMsg, {
          btn: ['确定','取消'] //按钮
        }, function(){
            formObj.isIgnoreSameOrder = 1;
            checkThePrice(formObj,function (res) {
              if(res.returnCode ===1){
                if(res.data.nonFinish){
                  // location.href = `/internalOrder/pay.do?orderId=${res.data.orderInfoId}`
                  location.href = `/pay/toPayOrCharge.do?payMethod=2&orderId=${res.data.orderInfoId}`
                }else {
                  location.href = `/ticketController/toTicketOrderSuccess.do?subOrderCode=${res.data.orderId}&orderId=${res.data.orderInfoId}`
                }
              }else if(res.returnCode === -400001){
                alert('请先登录',{closeBtn : 0},function () {
                  //跳转到首页
                  location.href = '/user/home.do';
                });
              }else {
                //否则就提示用户错误信息，然后跳转到酒店详情页面
              //  alert(res.returnMsg,{closeBtn : 0},function(){
                  // changeToPage();
               // });
                layer.open({
                  title: '提示'
                  ,content: res.returnMsg
                });
              }
            });
            // location.href = `/internalOrder/pay.do?orderId=${res.data.orderInfoId}`
            // location.href = `/ticketController/toTicketOrderSuccess.do?orderId=${res.data.orderId}`
        });

      } else {
        //否则就提示用户错误信息，然后跳转到酒店详情页面
       // alert(res.returnMsg,{closeBtn : 0},function(){
          // changeToPage();
       // });
        layer.open({
          title: '提示'
          ,content: res.returnMsg
        });
      }


    },"json")
}


module.exports = isComplete;



// WEBPACK FOOTER //
// ./src/js/ticketOrderConfirm/modules/isComplete.js